<template>
  <div>
    <v-main>
      <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0">Create a shop</h2>
            <v-spacer></v-spacer>
          </div>
          <div class="content">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
            <div>
              <p>Shop Name</p>
            <v-text-field
              v-model="form.name"
              solo
              flat
              label="Your shop"
              style="border-radius: 20px"
              :rules="[rules.required]"
            ></v-text-field>
            </div>
            <div>
            <p>Phone number</p>
            <v-text-field
              v-model="form.contactTel"
              label="Enter telephone"
              solo
              flat
              style="border-radius: 20px"
              v-mask="'###-###-####'"
              :rules="[rules.required]"
            ></v-text-field>
            </div>
            </v-form>
          </div>
          <div class="next">
            <p style="color: var(--neutral-black, #0C092A);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 150%; /* 21px */">If you already have an account</p>
            <v-btn
              style="
                display: flex;
                width: 327px;
                height: 56px;
                padding: 16px 133px;
                justify-content: center;
                align-items: center;
                border-radius: 20px;
                background: var(--color-primary, #07B53B);
              "
              dark
              block
              @click="next()"
              >Connect your LINE OA</v-btn
            >
          </div>
          <div class="center" >
            <span style="padding-top:5px;color: var(--neutral-grey-2, #858494);
text-align: center;

/* Body / Normal - Regular */
font-family: Rubik;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 150%;
padding-top:15px;">Already have an account? <a href="https://manager.line.biz">LINE OA</a></span>
          </div>

          <div class="progress1" style="padding-bottom: 15px">
            <span style="margin: 0; display: flex; justify-content: end;padding-top:20px">{{
              "2 / 2"
            }}</span>
            <v-progress-linear
              v-model="power"
              color="#25388D"
              height="8"
              style=""
            ></v-progress-linear>
          </div>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment-timezone'
export default {
  name: 'LoyaltySystemCreateShop',

  data () {
    return {
      power: 100,
      valid: true,
      form: {
        // userEmail: '',
        userCode: '',
        Email: '',
        contactTel: '',
        name: '',
        userName: '',
        password: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        userCreate: '',
        flexPicHomePage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.03.png?alt=media&token=550c3714-fa10-4ea8-b46d-527e7c5d4792',
        flexPicMembercardPage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.58.png?alt=media&token=6695dd3b-9f4f-4d6f-a3e0-a0ebf5de105b'
      },
      shop: '',
      tel: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        lenghth: v => v.length >= 8 || 'Must be at least 8 characters'
      }

    }
  },

  mounted () {
    const Email = this.$route.query.Email
    console.log(Email)
  },

  methods: {
    previous () {
      window.location = 'http://localhost:8081' + '/createAccount'
    },
    next () {
      if (this.$refs.form.validate() === true) {
        axios
          .get(this.DNS_IP + '/system_user/get?userName=' + this.$route.query.Email)
          .then(res => {
            console.log('res', res.data)
            if (res.data.status === false) {
              this.$swal({
                title: 'ต้องการ ลงทะเบียน ใช่หรือไม่?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ไม่'
              })
                .then(async (result) => {
                  this.form.Email = this.$route.query.Email
                  this.form.password = this.$route.query.password
                  this.form.CREATE_USER = 'System Create'
                  this.form.LAST_USER = 'System Create'
                  this.form.userCreate = 'System Create'
                  this.form.shopId = 'SD_' + moment().valueOf()
                  this.form.userCode = 'SYS_USER_' + moment().valueOf()
                  this.form.expire_date_trial = moment().add(7, 'days').format('YYYY-MM-DD')
                  console.log('form', this.form)
                  await axios
                    .post(
                      this.DNS_IP + '/system_shop/createShop',
                      this.form
                    )
                    .then(async (response) => {
                      this.$swal('สำเร็จ', 'สร้างร้านสำเร็จ', 'success')
                      var linkOA = `https://manager.line.biz/module/auth/v1/authorize?client_id=1656250423&redirect_uri=https://betask-loyalty-app.web.app/System/ManageShop?productName=loyalty${this.form.shopId}&response_type=code&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=register`
                      window.location = linkOA
                    // this.$router.push('createAShop?shopId=' + this.form.shopId)
                    })
                })
            }
          })
      }
    },
    openLinkOA () {
      window.open('https://manager.line.biz', '_blank')
    }
    // window.location =
    //   'https://manager.line.biz/sp/module/auth/v1/authorize/attach?client_id=1656250423&redirect_uri=https%3A%2F%2Fbetask-loyalty-app.web.app%2FSystem%2FManageShop%3FproductName%3Dloyalty&response_type=code&scope=account%3Amanage%20message%3Amark_as_read%20message%3Areceive%20message%3Asend%20profile%3Aread&state=register'
    // window.location = a
    // }
  }
}
</script>

<style scoped>
.progress {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  height: 8px !important;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.5rem;
}
.container {
  padding: 12px 25px;
}
.bg {
  background: var(--neutral-grey-5, #eef3fc);
  height: 100vh;
  display: flex;
  justify-content: center;
}
.center {
  display: flex;
  justify-content: center;
}
span {
  color: var(--neutral-grey-2, #858494);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.nav {
  display: flex;
  align-items: center;
  height: 100px;
}
.nav div {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/createShop.vue